export const SKILLS_MAP = {
  JAVASCRIPT: "JAVASCRIPT",
  TYPESCRIPT: "TYPESCRIPT",
  REACT: "REACT",
  REDUX: "REDUX",

  NODEJS: "NODEJS",
  NESTJS: "NESTJS",
  EXPRESS: "EXPRESS",

  HTML: "HTML",
  CSS: "CSS",
  SASS: "SASS",

  AWS: "AWS",

  PGSQL: "PGSQL",
  MYSQL: "MYSQL",
  MONGO: "MONGO",
  GRAPHQL: "GRAPHQL",

  JAVA: "JAVA",
  SPRING: "SPRING",

  ANGULAR: "ANGULAR",
  VUE: "VUE",
  BOOTSTRAP: "BOOTSTRAP",

  PYTHON: "PYTHON",
  MATLAB: "MATLAB",
  CPP: "CPP",
  C: "C",
};

export const TOOLS = {
  NPM: "NPM",
  YARN: "YARN",
  JENKINS: "JENKINS",
  LINUX: "LINUX",
  GIT: "GIT",
  DOCKER: "DOCKER",
  VSCODE: "VSCODE",
  INTELLIJ: "INTELLIJ",
  JIRA: "JIRA",
  CONFLUENCE: "CONFLUENCE",
  AGILE: "AGILE DEVELOPMENT",
};

export const SKILL_TIMELINE = {
  2021: [
    SKILLS_MAP.CSS,
    SKILLS_MAP.HTML,
    SKILLS_MAP.JAVASCRIPT,
    SKILLS_MAP.REACT,
    SKILLS_MAP.REDUX,
    SKILLS_MAP.NODEJS,
    SKILLS_MAP.NESTJS,
    SKILLS_MAP.AWS,
    SKILLS_MAP.MYSQL,
    SKILLS_MAP.SPRING,
    SKILLS_MAP.TYPESCRIPT,
    SKILLS_MAP.SASS,
    SKILLS_MAP.VUE,
  ],
  2020: [
    SKILLS_MAP.CSS,
    SKILLS_MAP.HTML,
    SKILLS_MAP.JAVASCRIPT,
    SKILLS_MAP.REACT,
    SKILLS_MAP.REDUX,
    SKILLS_MAP.NODEJS,
    SKILLS_MAP.NESTJS,
    SKILLS_MAP.EXPRESS,
    SKILLS_MAP.AWS,
    SKILLS_MAP.PGSQL,
    SKILLS_MAP.MONGO,
    SKILLS_MAP.TYPESCRIPT,
    SKILLS_MAP.SASS,
    SKILLS_MAP.VUE,
  ],
  2019: [
    SKILLS_MAP.CSS,
    SKILLS_MAP.HTML,
    SKILLS_MAP.JAVASCRIPT,
    SKILLS_MAP.REACT,
    SKILLS_MAP.REDUX,
    SKILLS_MAP.NODEJS,
    SKILLS_MAP.EXPRESS,
    SKILLS_MAP.AWS,
    SKILLS_MAP.PGSQL,
    SKILLS_MAP.MYSQL,
    SKILLS_MAP.MONGO,
    SKILLS_MAP.GRAPHQL,
    SKILLS_MAP.SASS,
    SKILLS_MAP.TYPESCRIPT,
  ],
  2018: [
    SKILLS_MAP.CSS,
    SKILLS_MAP.HTML,
    SKILLS_MAP.JAVASCRIPT,
    SKILLS_MAP.REACT,
    SKILLS_MAP.REDUX,
    SKILLS_MAP.NODEJS,
    SKILLS_MAP.EXPRESS,
    SKILLS_MAP.AWS,
    SKILLS_MAP.PGSQL,
    SKILLS_MAP.MYSQL,
    SKILLS_MAP.GRAPHQL,

    SKILLS_MAP.JAVA,
    SKILLS_MAP.ANGULAR,
    SKILLS_MAP.BOOTSTRAP,
    SKILLS_MAP.SASS,
  ],
  2017: [
    SKILLS_MAP.JAVASCRIPT,
    SKILLS_MAP.NODEJS,
    SKILLS_MAP.CSS,
    SKILLS_MAP.HTML,
    SKILLS_MAP.SASS,
    SKILLS_MAP.EXPRESS,
    SKILLS_MAP.AWS,
    SKILLS_MAP.PGSQL,

    SKILLS_MAP.JAVA,
    SKILLS_MAP.ANGULAR,
    SKILLS_MAP.VUE,
    SKILLS_MAP.BOOTSTRAP,
    SKILLS_MAP.SPRING,
  ],
  2016: [
    SKILLS_MAP.HTML,
    SKILLS_MAP.JAVASCRIPT,
    SKILLS_MAP.NODEJS,
    SKILLS_MAP.CSS,
    SKILLS_MAP.SASS,
    SKILLS_MAP.EXPRESS,
    SKILLS_MAP.AWS,
    SKILLS_MAP.PGSQL,

    SKILLS_MAP.JAVA,
    SKILLS_MAP.ANGULAR,
    SKILLS_MAP.BOOTSTRAP,
    SKILLS_MAP.SPRING,
  ],
  2015: [
    SKILLS_MAP.CSS,
    SKILLS_MAP.SASS,
    SKILLS_MAP.HTML,
    SKILLS_MAP.JAVASCRIPT,
    SKILLS_MAP.NODEJS,
    SKILLS_MAP.EXPRESS,
    SKILLS_MAP.AWS,
    SKILLS_MAP.PGSQL,

    SKILLS_MAP.JAVA,
    SKILLS_MAP.ANGULAR,
    SKILLS_MAP.BOOTSTRAP,
    SKILLS_MAP.SPRING,
  ],
  2014: [
    SKILLS_MAP.PYTHON,
    SKILLS_MAP.JAVA,
    SKILLS_MAP.ANGULAR,
    SKILLS_MAP.CSS,
    SKILLS_MAP.SASS,
    SKILLS_MAP.HTML,
    SKILLS_MAP.JAVASCRIPT,
    SKILLS_MAP.NODEJS,
    SKILLS_MAP.EXPRESS,
    SKILLS_MAP.BOOTSTRAP,
  ],
  2013: [SKILLS_MAP.PYTHON, SKILLS_MAP.MATLAB],
  2012: [SKILLS_MAP.C, SKILLS_MAP.CPP, SKILLS_MAP.JAVA, SKILLS_MAP.MATLAB],
  2011: [SKILLS_MAP.C, SKILLS_MAP.CPP, SKILLS_MAP.MATLAB, SKILLS_MAP.JAVA],
  2010: [SKILLS_MAP.C, SKILLS_MAP.CPP, SKILLS_MAP.MATLAB],
  2009: [SKILLS_MAP.C, SKILLS_MAP.CPP, SKILLS_MAP.MATLAB],
  2008: [SKILLS_MAP.C, SKILLS_MAP.CPP, SKILLS_MAP.MATLAB],
};

export const SKILL_ICONS = {
  [SKILLS_MAP.REACT]: "devicon-react-original-wordmark",
  [SKILLS_MAP.JAVASCRIPT]: "devicon-javascript-plain colored",
  [SKILLS_MAP.ANGULAR]: "devicon-angularjs-plain",
  [SKILLS_MAP.JAVA]: "devicon-java-plain-wordmark",
  [SKILLS_MAP.AWS]: "devicon-amazonwebservices-plain-wordmark",
  [SKILLS_MAP.NODEJS]: "devicon-nodejs-plain",
  [SKILLS_MAP.C]: "devicon-c-plain-wordmark",
  [SKILLS_MAP.CPP]: "devicon-cplusplus-plain-wordmark",
  [SKILLS_MAP.CSS]: "devicon-css3-plain-wordmark",
  [SKILLS_MAP.HTML]: "devicon-html5-plain-wordmark",
  [SKILLS_MAP.MONGO]: "devicon-mongodb-plain-wordmark",
  [SKILLS_MAP.EXPRESS]: "devicon-express-original",
  [SKILLS_MAP.PGSQL]: "devicon-postgresql-plain-wordmark",
  [SKILLS_MAP.BOOTSTRAP]: "devicon-bootstrap-plain-wordmark",
  [SKILLS_MAP.PYTHON]: "devicon-python-plain-wordmark",
  [SKILLS_MAP.VUE]: "devicon-vuejs-plain",
  [SKILLS_MAP.TYPESCRIPT]: "devicon-typescript-plain",
  [SKILLS_MAP.SASS]: "devicon-sass-plain",
  [SKILLS_MAP.MYSQL]: "devicon-mysql-plain-wordmark",
  [SKILLS_MAP.SPRING]: "devicon-spring-plain-wordmark",
  [SKILLS_MAP.MATLAB]: "devicon-matlab-plain",
  [SKILLS_MAP.GRAPHQL]: "devicon-graphql-plain-wordmark",
  [SKILLS_MAP.REDUX]: "devicon-redux-original",
  [SKILLS_MAP.NESTJS]: "devicon-nestjs-plain",
};
